import { render, staticRenderFns } from "./section-privacy-politics.vue?vue&type=template&id=42a0b34a"
import script from "./section-privacy-politics.vue?vue&type=script&lang=js"
export * from "./section-privacy-politics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports